import Image from "next/image";
import { Box } from "~/components/Box/Box";
import { Button } from "~/components/Button/Button";
import { Text } from "~/components/Text/Text";
import { ButtonLink } from "../ButtonLink/ButtonLink";
import { Stack } from "../Stack/Stack";

export default function AppError(props: {
  error: Error & { digest?: string };
  reset: () => void;
  redirect?: { label: string; href: string };
}) {
  const { error, reset, redirect } = props;

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      height="full"
      width="full"
      padding="10"
    >
      <Stack align="center" space="8">
        <Text size="large" align="center" weight="strong">
          Something has gone wrong
        </Text>
        <Image
          src="/images/jetserror.png"
          width={297}
          height={230}
          alt="Error Image"
        />
        <Box>
          <Text align="center">We&#39;ve logged the error.</Text>
          <Text align="center">
            Please try again or return to the home page
          </Text>
        </Box>
        <Stack space="4">
          <Button onClick={reset} primary>
            Try again
          </Button>
          {redirect && (
            <ButtonLink href={redirect.href} primary>
              {redirect.label}
            </ButtonLink>
          )}
        </Stack>
        <Text size="small" weight="regular">
          More Info: {error.message}
        </Text>
      </Stack>
    </Box>
  );
}
